import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

export const FooterDark = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_menu-delicioso-2/artifacts/o8djjetr_ChatGPT%20Image%2016%20dic%202025%2C%2013_36_57.png"
                alt="Mr. Crunch 28"
                className="h-12 w-12 object-contain rounded-full"
              />
              <h3 className="text-xl font-bold bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
                Mr. Crunch 28
              </h3>
            </div>
            <p className="text-orange-500 font-semibold italic mb-2">
              ¡Crujiente por fuera, irresistible por dentro!
            </p>
            <p className="text-gray-400">
              Elevando la experiencia del pollo frito y la cocina casual desde 2023.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="#inicio" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#menu" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Menú
                </a>
              </li>
              <li>
                <a href="#sobre-nosotros" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-gray-400 hover:text-orange-500 transition-colors">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Contacto</h4>
            <ul className="space-y-2 text-gray-400">
              <li>WhatsApp: 877 177 8264</li>
              <li className="break-all">Email: mrcrunch2friedchicken@gmail.com</li>
              <li>Calle Luis G. Urbina #1490</li>
              <li>Col. 28 de Junio, Cd. Acuña, Coah.</li>
              <li className="pt-2">
                <span className="font-semibold text-gray-300">Horarios:</span>
              </li>
              <li>Jue-Vie: 5:00 PM - 10:00 PM</li>
              <li>Sáb-Dom: 12:00 PM - 10:00 PM</li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Síguenos</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/17Guwwc5NV/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 transition-all shadow-lg hover:shadow-red-900/50"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/mrcrunchfriedchicken"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 transition-all shadow-lg hover:shadow-red-900/50"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://wa.me/528771228589"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 transition-all shadow-lg hover:shadow-red-900/50"
              >
                <FaWhatsapp className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-900 mt-8 pt-8 text-center text-gray-400">
          <p>© {currentYear} Mr. Crunch 28. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
